import { Fragment } from 'react'

//* Components
import ReviewItem from './ReviewItem';
import Text from '@/components/common/Text';

//* Style
import ProductCommentsSectionStyle from './style';

const ProductCommentsSection = ({ reviews }) => {
    return reviews?.length > 0 ? (
        <ProductCommentsSectionStyle>
            <Text
                className={'h2-L font-futura-medium comment-title'}
                text={'whatOthersAreSaying'}
            />

            <div className='comments'>
                {reviews.map((review, key) => (
                    <Fragment key={key}>
                        <ReviewItem  {...review} />
                        {review.replier ? (
                            <ReviewItem
                                author={review.replier}
                                content={review.reply}
                                date={review.replied_at}
                                rating={null}
                            />
                        ) : null}
                    </Fragment>
                ))}
            </div>
        </ProductCommentsSectionStyle>
    ) : null;
};

export default ProductCommentsSection;
